/**
 * Heurística UX (no es el intent del backend): ¿parece descripción de lotes
 * más que un nombre de lugar? Señala “modo IA” y evita geocode en vivo.
 *
 * @param {string} query
 * @returns {boolean}
 */
export function looksLikeNlSearchQuery(query) {
  const text = String(query || '').trim();
  if (!text) return false;

  const words = text.split(/\s+/).filter(Boolean);
  if (words.length >= 3) return true;
  if (/\d/.test(text)) return true;
  if (/m²|m2|\bm2\b|metros?|hectáreas?|\bha\b/i.test(text)) return true;
  if (/\b(bald[ií]os?|esquina|cloaca|cerrado|country|rurales?|urbanos?|suburbano|lotes?|terrenos?|parcelas?|sin\s+construir|inundaci[oó]n|potencial|venta|alquiler|dormitorios?|deptos?|departamentos?|baratos?|econ[oó]micos?|caros?|costosos?|precio|d[oó]lares?)\b/i.test(text)) {
    return true;
  }
  return false;
}
